@import '../../../global/styles/media-queries.scss';

:host {
    .background {
        padding-top: 96px;
        padding-bottom: 24px;
        background: rgb(0, 0, 0);
        background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(67, 67, 67, 1) 100%);
        border-bottom: 3px solid white;
        .container {
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: baseline;
            max-width: var(--csb-content-width);
            padding-right: 44px;
            box-sizing: border-box;

            @media screen and (max-width: 1490px) {
                padding-left: 24px;
                padding-right: 24px;
            }
            
        }
    }

    h1 {
        color: white;
    }
    p {
        color: white;
        font-size: 20px;
        font-weight: 500;
        margin: 10px;
        a {
            color: white;
        }
    }
    table {
        border-collapse: collapse;
        width: 100%;
    }
    table td {
        border: 1px solid white;
    }
    table tr:first-child {
        border-top: 0;
        td {
            border-top: 0;
        }
    }
    table tr:last-child td {
        border-bottom: 0;
    }
    table tr td:first-child {
        border-left: 0;
    }
    table tr td:last-child {
        border-right: 0;
    }

    td {
        padding: 24px 32px;

        .title {
            color: white;
            font-size: 20px;
            font-weight: 700;
        }
        .contact {
            color: white;
        }
    }
}
